import React from "react";
import styled from "styled-components";
import { Flex, Box } from "rebass/styled-components";
import { Link as FooterLink } from "../../components/atoms/footer/link";
import { Tooltip } from "../atoms/tooltip";
import { SideFooterDropdown } from "../organisms/nav/sideFooterDropDown";
import { FaInstagram, FaDiscord, FaFacebookF, FaYoutube } from "react-icons/fa";
import { FaXTwitter } from "react-icons/fa6";
import { FollowLinks } from "./footer";

const StyledFlex = styled(Flex)`
  width: 100%;
  height: 20px;
  justify-content: flex-start;
`;

const DropdownContainer = styled(Tooltip)`
  margin: -20px;
  padding-left: 10px;
  padding-right: 0px;
  padding-top: 10px;
  padding-bottom: 10px;
`;

const Text = styled(FooterLink)`
  padding-right: 10px;
  &:hover {
    color: ${(props) => props.theme.colors.envy};
  }
`;

const Copyright = styled(Box)`
  padding-right: 10px;
`;

const More = styled(Box)`
  &:hover {
    color: ${(props) => props.theme.colors.envy};
    cursor: pointer;
  }
`;

const SocialLinks = styled(Box)`
  margin-bottom: ${(props) => props.theme.space[3]}px;

  @media (max-width: ${(props) => props.theme.breakpoints[1]}) {
    align-self: flex-end;
  }
`;

// let Em = styled.span`
//   color: ${(props) => props.theme.colors.envy};
//   font-weight: 500;
// `;

const Links = [
  {
    to: "/legal/terms-of-use",
    title: "Terms",
  },
  {
    to: "/howitworks",
    title: "How it works",
  },
  // {
  //   to: "/allstarBot",
  //   title: "AllstarBot",
  // },
  {
    to: "/careers",
    title: "Careers",
  },
];

export function FooterLinks(props) {
  return (
    <Flex flexDirection="column">
      <StyledFlex>
        {Links.map((link, index) => {
          return (
            <Text
              key={index}
              variant="link.railFooter"
              to={link.to}
              href={link.href}
              target="_blank"
            >
              {link.title}
            </Text>
          );
        })}
        <More ml={2} variant="link.railFooter">
          More...
          <DropdownContainer
            type="click"
            position={{
              top: "calc(-650% - 120px)",
              right: "10px",
            }}
            tooltipContent={<SideFooterDropdown />}
          ></DropdownContainer>
        </More>
      </StyledFlex>
      {props.game === "league" ? (
        <>
          {" "}
          <Flex variant="link.railFooter" pt={3} fontSize={"10px"}>
            Allstar isn't endorsed by Riot Games and doesn't reflect the views
            or opinions of Riot Games or anyone officially involved in producing
            or managing Riot Games properties. Riot Games, and all associated
            properties are trademarks or registered trademarks of Riot Games,
            Inc.
          </Flex>
        </>
      ) : (
        <></>
      )}

      <Flex>
        <Copyright variant="link.railFooter" marginTop={12}>
          &copy; {new Date().getFullYear()} Allstar, Inc.
        </Copyright>
      </Flex>
    </Flex>
  );
}
